<template>
  <div class="download-ads">
    <div class="download-ads__container">
      <div class="download-ads__app-info">
        <div class="download-ads__app-icon">
          <img class="download-ads__icon-img" src="@/assets/ads/icon.png" alt="App icon" />
        </div>
        <div class="download-ads__separator"></div>
        <div class="download-ads__features">
          <div class="download-ads__feature">
            <img class="download-ads__feature-icon" src="@/assets/ads/safe.svg" alt="Safety" />
            <div class="download-ads__feature-name">safety</div>
          </div>
          <div class="download-ads__feature">
            <img class="download-ads__feature-icon" src="@/assets/ads/fast.svg" alt="Fast" />
            <div class="download-ads__feature-name">fast</div>
          </div>
          <div class="download-ads__feature">
            <img class="download-ads__feature-icon" src="@/assets/ads/noads.svg" alt="No Ads" />
            <div class="download-ads__feature-name">No Ads</div>
          </div>
        </div>
        <div class="download-ads__separator"></div>
        <div class="download-ads__qr">
          <img class="download-ads__qr-img" src="@/assets/ads/qr.png" alt="QR Code" />
        </div>
        <div class="download-ads__separator"></div>
        <a class="download-ads__download" :href="downloadLink" :target="domainConfig?.downloadUrl ? '_blank' : '_self'" rel="noopener noreferrer">
          <img class="download-ads__download-icon" src="@/assets/ads/download.png" alt="Download" />
          <div class="download-ads__download-text">Download</div>
        </a>
      </div>
      <div class="download-ads__social">
        <div class="download-ads__telegram">
          <div class="download-ads__telegram-icon"></div>
          <div class="download-ads__telegram-text">Join the group</div>
        </div>
      </div>
      <div class="download-ads__icons">
        <div class="download-ads__icons-container">
          <img class="download-ads__social-icon" src="@/assets/ads/face.svg" alt="Facebook" />
          <img class="download-ads__social-icon" src="@/assets/ads/ins.svg" alt="Instagram" />
          <img class="download-ads__social-icon" src="@/assets/ads/x.svg" alt="X (Twitter)" />
          <img class="download-ads__social-icon" src="@/assets/ads/telegram.svg" alt="Telegram" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from '@/mixin/common'

export default {
  name: 'DownloadAds',
  mixins: [common],
  computed: {
    downloadLink() {
      return this.domainConfig?.downloadUrl || '/movie-download/'
    }
  }
};
</script>

<style lang="scss">
@import '@/css/variables.scss';

.download-ads {
	padding: 0 rem(80);
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: space-between;
	align-self: stretch;
	position: relative;

	&__container {
		display: flex;
		flex-direction: row;
		align-items: flex-start;
		justify-content: space-between;
		width: 100%;
		gap: rem(40);
	}

	&__app-info {
		background: linear-gradient(270deg, rgba(42, 40, 46, 1) 0%, rgba(13, 12, 15, 1) 100%);
		border-radius: rem(28);
		border: 2px solid rgba(255, 255, 255, 0.04);
		padding: rem(40);
		display: flex;
		flex-direction: row;
		gap: auto;
		align-items: center;
		justify-content: space-around;
		flex-shrink: 0;
		position: relative;
		flex: 1;
	}

	&__app-icon {
		flex-shrink: 0;
		width: rem(120);
		height: rem(120);
		position: relative;
	}

	&__icon-img {
		border-radius: rem(28);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__separator {
		background: #ffffff;
		opacity: 0.1;
		width: 1px;
		height: rem(60);
		position: relative;
		margin: 0 rem(20);
	}

	&__features {
		display: flex;
		flex-direction: column;
		gap: rem(8);
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		width: rem(126);
		position: relative;
	}

	&__feature {
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;
	}

	&__feature-icon {
		flex-shrink: 0;
		width: rem(32);
		height: rem(32);
		position: relative;
	}

	&__feature-name {
		color: #ffffff;
		text-align: left;
		font-size: rem(18);
		line-height: rem(20);
		font-weight: 900;
		text-transform: uppercase;
		position: relative;
	}

	&__qr {
		width: rem(120);
		height: rem(120);
		position: relative;
	}

	&__qr-img {
		border-radius: rem(24);
		border: 1px solid rgba(255, 255, 255, 0.1);
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	&__download {
		background: linear-gradient(180deg, rgba(177, 50, 251, 1) 0%, rgba(254, 50, 75, 1) 100%);
		border-radius: rem(24);
		border: 1px solid rgba(255, 255, 255, 0.1);
		padding: rem(18) rem(14);
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		width: rem(120);
		height: rem(120);
		position: relative;
		cursor: pointer;
		text-decoration: none;
		color: inherit;
	}

	&__download-icon {
		width: rem(44);
		height: rem(48);
		position: relative;
	}

	&__download-text {
		color: #ffffff;
		text-align: left;
		font-size: rem(18);
		line-height: rem(18);
		font-weight: 700;
		position: relative;
	}

	&__social {
		background: linear-gradient(270deg, rgba(13, 12, 15, 1) 0%, rgba(42, 40, 46, 1) 100%);
		border-radius: rem(24);
		border: 2px solid rgba(255, 255, 255, 0.04);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: rem(200);
		height: rem(200);
		position: relative;
	}

	&__telegram {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: rem(16);
	}

	&__telegram-icon {
		width: rem(88);
		height: rem(88);
		background-image: url('~@/assets/ads/telegram.svg');
		background-repeat: no-repeat;
		background-position: center;
		background-size: contain;
	}

	&__telegram-text {
		color: #ffffff;
		font-size: rem(16);
		line-height: rem(16);
		font-weight: 400;
	}

	&__icons {
		background: linear-gradient(270deg, rgba(42, 40, 46, 1) 0%, rgba(13, 12, 15, 1) 100%);
		border-radius: rem(24);
		border: 2px solid rgba(255, 255, 255, 0.04);
		padding: rem(24);
		width: rem(200);
		height: rem(200);
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		box-sizing: border-box;
	}

	&__icons-container {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		width: 100%;
		height: 100%;
		justify-content: space-between;
		align-content: space-between;
	}

	&__social-icon {
		width: calc(50% - rem(8));
		height: calc(50% - rem(8));
		object-fit: contain;
		box-sizing: border-box;
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.download-ads {
		// PC端特定样式
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.download-ads {
		padding: 0 rem(16);
		margin: rem(20) 0;

		&__container {
			flex-direction: column;
			gap: rem(20);
		}

		&__app-info {
			flex-direction: column;
			padding: rem(20);
			gap: rem(20);
			align-items: center;
		}

		&__separator {
			width: 80%;
			height: 1px;
			margin: 0;
		}

		&__features {
			width: 100%;
			align-items: center;
		}

		&__social,
		&__icons {
			width: 100%;
			height: auto;
			padding: rem(20);
			min-height: rem(160);
		}

		&__icons-container {
			width: 100%;
			justify-content: center;
			gap: rem(16);
		}

		&__social-icon {
			width: calc(50% - rem(8));
			height: auto;
		}
	}
}
</style> 